export * as Instrumentation from './config';
export { useObservability } from './openTelemetry';
export * as Attributes from './attributes';

export { getJourneyTracker } from './journeyTracker/journeyTracker';
export { createJourneyTrackingMiddleware } from './journeyTracker/journeyTrackingMiddleware';

import { createTrace, closeTrace, addAnalytics, addLog, addMetrics } from './openTelemetry';
import { setUserContext, updateLabels } from './coralogix';

export const Observability = {
    createTrace,
    closeTrace,
    addAnalytics,
    addLog,
    addMetrics,
    setUserContext,
    updateLabels,
};
